import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) {
      setError("Le password non coincidono.");
      return;
    }
    if (next.length < 8) {
      setError("La nuova password deve avere almeno 8 caratteri.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: next });
      toast.success("Password reimpostata. Ora puoi accedere.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy p-6">
      <div className="w-full max-w-md bg-white rounded-lg border border-navy/10 p-8 shadow-xl">
        <div className="w-12 h-12 rounded-md bg-gold/15 flex items-center justify-center mb-5">
          <KeyRound className="w-6 h-6 text-gold" />
        </div>
        <p className="text-xs tracking-[0.15em] uppercase font-bold text-gold">Recupero credenziali</p>
        <h1 className="font-display text-2xl font-bold text-navy mt-2">Nuova password</h1>
        {!token ? (
          <>
            <p className="text-sm text-destructive mt-3" data-testid="reset-invalid">Link non valido: token mancante.</p>
            <Link to="/password-dimenticata" className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-navy hover:text-navy-hover transition-colors">
              <ArrowLeft className="w-4 h-4" /> Richiedi un nuovo link
            </Link>
          </>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="next">Nuova password</Label>
              <Input id="next" type="password" required value={next} onChange={(e) => setNext(e.target.value)}
                className="h-11" data-testid="reset-new-password" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm">Conferma nuova password</Label>
              <Input id="confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                className="h-11" data-testid="reset-confirm-password" />
            </div>
            {error && <p className="text-sm text-destructive font-medium" data-testid="reset-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full h-11 bg-navy hover:bg-navy-hover text-white font-semibold">
              {loading ? "Salvataggio…" : "Reimposta password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
